import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ListGruppiStudioDTO, ListSelectDTO } from 'src/app/model/newModel';
import { ConstantsCLA } from '../../../shared/constants-cla';
import {
  SelectCommand,
  SearchGruppoStudioCommand,
} from '../../../model/command-model';

@Injectable({
  providedIn: 'root',
})
export class GroupsService {
  constructor(private http: HttpClient) {}

  search(idInstructor: number, idCorsoLaurea: number, idSessioneOla: number) {
    const command = new SearchGruppoStudioCommand();
    command.idInstructor = !!idInstructor ? '' + idInstructor : null;
    command.idCorsoLaurea = idCorsoLaurea;
    command.idSessioneOla = idSessioneOla;
    command.skip = 0;
    command.take = 10;
    return this.http.post<ListGruppiStudioDTO>(
      ConstantsCLA.SEARCH_GRUPPO_STUDIO_URL,
      command
    );
  }

  previousPage(
    idInstructor: number,
    idCorsoLaurea: number,
    idSessioneOla: number,
    skip: number,
    take: number
  ) {
    const skipNew = skip - 1 < 0 ? 0 : skip - 1;
    const command = new SearchGruppoStudioCommand();
    command.idInstructor = !!idInstructor ? '' + idInstructor : null;
    command.idCorsoLaurea = idCorsoLaurea;
    command.idSessioneOla = idSessioneOla;
    command.skip = skipNew;
    command.take = take;
    return this.http.post<ListGruppiStudioDTO>(
      ConstantsCLA.SEARCH_GRUPPO_STUDIO_URL,
      command
    );
  }

  nextPage(
    idInstructor: number,
    idCorsoLaurea: number,
    idSessioneOla: number,
    skip: number,
    take: number,
    count: number
  ) {
    const skipNew = skip + 1;
    const command = new SearchGruppoStudioCommand();
    command.idInstructor = !!idInstructor ? '' + idInstructor : null;
    command.idCorsoLaurea = idCorsoLaurea;
    command.idSessioneOla = idSessioneOla;
    command.skip = skipNew;
    command.take = take;
    return this.http.post<ListGruppiStudioDTO>(
      ConstantsCLA.SEARCH_GRUPPO_STUDIO_URL,
      command
    );
  }

  goToPage(
    idInstructor: number,
    idCorsoLaurea: number,
    idSessioneOla: number,
    idVaiA: string,
    take: number
  ) {
    const command = new SearchGruppoStudioCommand();
    command.idInstructor = !!idInstructor ? '' + idInstructor : null;
    command.idCorsoLaurea = idCorsoLaurea;
    command.idSessioneOla = idSessioneOla;
    command.skip = Number(idVaiA);
    command.take = take;
    return this.http.post<ListGruppiStudioDTO>(
      ConstantsCLA.SEARCH_GRUPPO_STUDIO_URL,
      command
    );
  }

  selectInstructors(idSessione: number) {
    const command = new SelectCommand();
    command.idSessioneOla = idSessione;
    return this.http.post<ListSelectDTO>(
      ConstantsCLA.INSTRUCTORS_COMBO_URL,
      command
    );
  }
}
